import { createAction, props } from '@ngrx/store';

export const TagAssignmentPanelStatusChanged = createAction(
  '[Data Customization: Tag Assignment]: Panel Status Changed',
);

export const TagTypeChanged = createAction(
  '[Data Customization: Tag Assignment]: Tag Type Changed',
  props<{ tagType: string }>(),
);

export const BrandCodeChanged = createAction(
  '[Data Customization: Tag Assignment]: Brand Code Changed',
  props<{ brandCode: string }>(),
);

export const ClearTagAssignmentOptions = createAction(
  '[Data Customization: Tag Assignment]: Clear Tag Assignment Options',
);
